export interface Movie {
  id: string;
  title: string;
  type: "电影" | "电视剧";
  genres: string[];
  region: string;
  year: number;
  rating: number;
  poster: string;
  backdrop: string;
  duration: string;
  director: string;
  actors: string[];
  language: string;
  releaseDate: string;
  summary: string;
  story: string;
  tags: string[];
  views: number;
  featured: boolean;
}

export const movies: Movie[] = [
  {
    id: "m01",
    title: "星际迷航：归途",
    type: "电影",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2025,
    rating: 8.7,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20design%20of%20a%20lone%20astronaut%20facing%20a%20giant%20glowing%20planet%2C%20deep%20navy%20blue%20tone%20with%20warm%20orange%20rim%20light%2C%20dramatic%20volumetric%20lighting%2C%20film%20grain%2C%20elegant%20composition%2C%20professional%20key%20art%2C%20high%20detail&width=600&height=900&seq=movie-01-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20sci-fi%20space%20scene%20with%20a%20spaceship%20drifting%20toward%20a%20massive%20blue%20planet%2C%20deep%20navy%20and%20orange%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20nebula%2C%20wide%20film%20still%2C%20high%20detail&width=1600&height=900&seq=movie-01-backdrop&orientation=landscape",
    duration: "142分钟",
    director: "克里斯·诺兰",
    actors: ["杰克·汤普森", "艾米莉·布朗", "马克·李"],
    language: "英语",
    releaseDate: "2025-07-18",
    summary: "一支深空探索队在返航途中遭遇未知引力场，必须在天体崩塌前找到回家的坐标。",
    story:
      "人类首次跨越柯伊伯带的载人探索任务意外被困在一颗正在坍缩的未知行星附近。船长艾略特与工程师玛雅必须在有限的燃料和不断缩小的生存窗口中，解开一组来自远古文明的导航信号。影片以宏大的太空奇观和细腻的人性刻画，讲述关于归途与信念的故事。",
    tags: ["太空", "硬科幻", "IMAX"],
    views: 1284300,
    featured: true,
  },
  {
    id: "m02",
    title: "长安十二时",
    type: "电视剧",
    genres: ["古装", "悬疑"],
    region: "中国大陆",
    year: 2025,
    rating: 9.1,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20chinese%20historical%20drama%20poster%20of%20a%20lone%20scholar%20in%20silk%20robes%20holding%20a%20lantern%20in%20an%20ancient%20city%20alley%20at%20dusk%2C%20deep%20blue%20night%20tone%20with%20orange%20lantern%20glow%2C%20moody%20lighting%2C%20film%20grain%2C%20elegant%20key%20art%2C%20high%20detail&width=600&height=900&seq=movie-02-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=sweeping%20view%20of%20ancient%20chinese%20capital%20city%20at%20night%20with%20glowing%20lanterns%2C%20palace%20rooftops%20and%20mist%2C%20deep%20blue%20and%20warm%20orange%20cinematic%20grading%2C%20epic%20historical%20drama%20film%20still%2C%20high%20detail&width=1600&height=900&seq=movie-02-backdrop&orientation=landscape",
    duration: "45分钟/集",
    director: "曹盾",
    actors: ["雷嘉", "易然", "周一围"],
    language: "汉语普通话",
    releaseDate: "2025-03-12",
    summary: "上元节前夕，一场灭城危机在十二个时辰内悄然逼近，一个小吏要在黎明前揭开真相。",
    story:
      "大唐都城上元灯会前夜，负责巡查的小吏沈砚意外截获一封可疑密信。随着调查深入，他发现一场针对整座城市的阴谋正逐步收网。在有限的十二个时辰里，沈砚联合旧友与神秘的女医师，追踪线索穿越市井与宫闱，最终揭开隐藏在繁华之下的惊天秘密。",
    tags: ["古装", "权谋", "群像"],
    views: 3120700,
    featured: true,
  },
  {
    id: "m03",
    title: "霓虹之城",
    type: "电影",
    genres: ["犯罪", "惊悚"],
    region: "中国香港",
    year: 2024,
    rating: 7.9,
    poster:
      "https://readdy.ai/api/search-image?query=neo-noir%20crime%20movie%20poster%20of%20a%20detective%20silhouette%20in%20a%20rainy%20neon%20city%20street%2C%20deep%20blue%20night%20with%20orange%20neon%20reflections%2C%20dramatic%20contrast%20lighting%2C%20film%20grain%2C%20elegant%20key%20art%2C%20high%20detail&width=600&height=900&seq=movie-03-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=rain-soaked%20neon%20metropolis%20at%20night%20with%20reflective%20streets%20and%20glowing%20signs%2C%20deep%20blue%20and%20orange%20neo-noir%20cinematic%20grading%2C%20moody%20atmosphere%2C%20film%20still%2C%20high%20detail&width=1600&height=900&seq=movie-03-backdrop&orientation=landscape",
    duration: "126分钟",
    director: "韦家辉",
    actors: ["刘峰", "郑秀文", "林家栋"],
    language: "粤语",
    releaseDate: "2024-11-02",
    summary: "一桩连环悬案牵出城市地下世界的暗流，老刑警必须在真相与正义之间做出抉择。",
    story:
      "连续三起离奇案件让整座城市人心惶惶。即将退休的老刑警周振国被重新召回，与年轻女警探联手调查。随着线索指向城市最繁华的霓虹区，他发现案件背后隐藏着一个庞大的利益网络。影片以冷峻的镜头语言，勾勒出都市丛林中的人性挣扎。",
    tags: ["犯罪", "警匪", "港片"],
    views: 986300,
    featured: true,
  },
  {
    id: "m04",
    title: "春日来信",
    type: "电视剧",
    genres: ["爱情", "都市"],
    region: "韩国",
    year: 2025,
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=romantic%20korean%20drama%20poster%20of%20a%20young%20woman%20holding%20a%20letter%20under%20spring%20blossoms%2C%20soft%20warm%20light%20with%20gentle%20blue%20sky%20and%20orange%20sunset%20glow%2C%20dreamy%20bokeh%2C%20elegant%20key%20art%2C%20high%20detail&width=600&height=900&seq=movie-04-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=spring%20city%20park%20avenue%20lined%20with%20blossom%20trees%20at%20golden%20hour%2C%20warm%20orange%20sunlight%20and%20soft%20blue%20shadows%2C%20romantic%20cinematic%20film%20still%2C%20dreamy%20bokeh%2C%20high%20detail&width=1600&height=900&seq=movie-04-backdrop&orientation=landscape",
    duration: "60分钟/集",
    director: "金恩淑",
    actors: ["李知恩", "朴叙俊", "金泰梨"],
    language: "韩语",
    releaseDate: "2025-04-05",
    summary: "一封迟到多年的信，把两个错过彼此的人重新拉回同一个春天。",
    story:
      "图书编辑韩秀雅在整理旧居时发现一封从未寄出的信，收信人正是她大学时代的恋人。带着忐忑与好奇，她踏上寻找对方的旅程。多年后的重逢让两人重新审视当初的误会与遗憾。剧集以细腻的情感铺陈和清新的画面，讲述关于时间、错过与和解的故事。",
    tags: ["浪漫", "治愈", "高颜值"],
    views: 1540900,
    featured: true,
  },
  {
    id: "m05",
    title: "深海回声",
    type: "电影",
    genres: ["科幻", "悬疑"],
    region: "中国大陆",
    year: 2025,
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=underwater%20sci-fi%20thriller%20movie%20poster%20of%20a%20submarine%20diving%20into%20a%20glowing%20ocean%20trench%2C%20deep%20navy%20blue%20with%20orange%20bioluminescent%20glow%2C%20dramatic%20lighting%2C%20film%20grain%2C%20elegant%20key%20art%2C%20high%20detail&width=600&height=900&seq=movie-05-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=mysterious%20deep%20ocean%20trench%20illuminated%20by%20glowing%20blue%20and%20orange%20bioluminescence%2C%20submarine%20silhouette%20in%20the%20distance%2C%20cinematic%20underwater%20film%20still%2C%20atmospheric%2C%20high%20detail&width=1600&height=900&seq=movie-05-backdrop&orientation=landscape",
    duration: "134分钟",
    director: "郭帆",
    actors: ["吴京", "张译", "倪妮"],
    language: "汉语普通话",
    releaseDate: "2025-08-22",
    summary: "深海科考站收到一段来自万米海沟的神秘信号，它竟与失踪多年的母船完全一致。",
    story:
      "海洋地质学家陈默带领团队深入马里亚纳海沟执行勘探任务时，意外捕捉到一段规律的人造声波。信号源来自一处不该存在的人工结构。随着下潜深度增加，队员们逐渐意识到，他们面对的可能不是自然现象。影片以压迫感十足的氛围营造，探讨人类认知边界与深海未知。",
    tags: ["深海", "硬科幻", "悬疑"],
    views: 1120500,
    featured: true,
  },
  {
    id: "m06",
    title: "江湖夜雨",
    type: "电视剧",
    genres: ["武侠", "古装"],
    region: "中国大陆",
    year: 2024,
    rating: 8.8,
    poster:
      "https://readdy.ai/api/search-image?query=wuxia%20martial%20arts%20drama%20poster%20of%20a%20swordsman%20standing%20in%20falling%20rain%20at%20night%2C%20deep%20blue%20mood%20with%20a%20single%20orange%20lantern%20glow%2C%20dynamic%20pose%2C%20film%20grain%2C%20elegant%20key%20art%2C%20high%20detail&width=600&height=900&seq=movie-06-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20mountain%20pass%20in%20rain%20at%20dusk%20with%20a%20lone%20swordsman%20silhouette%2C%20deep%20blue%20mist%20and%20warm%20orange%20afterglow%2C%20cinematic%20wuxia%20film%20still%2C%20high%20detail&width=1600&height=900&seq=movie-06-backdrop&orientation=landscape",
    duration: "48分钟/集",
    director: "李木戈",
    actors: ["张凌赫", "白鹿", "陈星旭"],
    language: "汉语普通话",
    releaseDate: "2024-09-18",
    summary: "师门覆灭之后，一个少年背负血仇踏入江湖，却发现仇人竟是自己最敬重的人。",
    story:
      "少年江晚舟亲眼目睹师门在一夜之间被灭。十年后，学艺有成的他重回江湖寻找真凶，一路结识了亦正亦邪的侠客与神秘的药王谷主。当真相逐渐浮出水面，他发现当年的惨案背后还牵扯着一场更大的武林浩劫。剧集以写意的打斗和克制的叙事，呈现江湖的快意与苍凉。",
    tags: ["武侠", "复仇", "群像"],
    views: 2310800,
    featured: true,
  },
  {
    id: "m07",
    title: "时间旅人的妻子",
    type: "电影",
    genres: ["爱情", "奇幻"],
    region: "英国",
    year: 2024,
    rating: 7.6,
    poster:
      "https://readdy.ai/api/search-image?query=romantic%20fantasy%20movie%20poster%20of%20a%20couple%20reaching%20for%20each%20other%20across%20a%20swirling%20clock%20motif%2C%20soft%20blue%20tones%20with%20warm%20orange%20highlights%2C%20dreamy%20lighting%2C%20film%20grain%2C%20elegant%20key%20art%2C%20high%20detail&width=600&height=900&seq=movie-07-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=surreal%20landscape%20blending%20seasons%20around%20a%20couple%20silhouette%2C%20swirling%20time%20and%20glowing%20soft%20blue%20and%20orange%20light%2C%20romantic%20cinematic%20film%20still%2C%20dreamy%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=movie-07-backdrop&orientation=landscape",
    duration: "118分钟",
    director: "理查德·柯蒂斯",
    actors: ["汤姆·希德勒斯顿", "艾丽西亚·维坎德"],
    language: "英语",
    releaseDate: "2024-06-14",
    summary: "一个会不受控制穿越时间的男人，用一生等待与爱人一次又一次的重逢。",
    story:
      "图书馆管理员亨利患有一种罕见的基因缺陷，他会不受控制地穿越到过去或未来。在一次次意外的时空跳跃中，他遇见了画家克莱尔，两人跨越时间相爱。然而时间从未站在他们这边，每一次相聚都可能意味着下一次离别。影片以温柔而忧伤的笔触，讲述爱与等待。",
    tags: ["时空", "催泪", "文艺"],
    views: 742100,
    featured: false,
  },
  {
    id: "m08",
    title: "都市浮生记",
    type: "电视剧",
    genres: ["都市", "家庭"],
    region: "中国大陆",
    year: 2025,
    rating: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20poster%20of%20a%20family%20silhouette%20against%20a%20city%20skyline%20at%20dusk%2C%20cool%20blue%20tones%20with%20warm%20orange%20window%20lights%2C%20cinematic%20lighting%2C%20elegant%20key%20art%2C%20high%20detail&width=600&height=900&seq=movie-08-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20blue%20hour%20with%20warm%20orange%20apartment%20windows%20glowing%2C%20cinematic%20urban%20film%20still%2C%20moody%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=movie-08-backdrop&orientation=landscape",
    duration: "45分钟/集",
    director: "张晓波",
    actors: ["海清", "张颂文", "周迅"],
    language: "汉语普通话",
    releaseDate: "2025-02-20",
    summary: "一家三代人在大城市里各自奔忙，琐碎日常中藏着最真实的温情与和解。",
    story:
      "退休教师李淑芬与事业有成的儿子、叛逆的孙女同住一处老小区。三代人因生活习惯与价值观差异摩擦不断，却在一次次家庭变故中重新理解彼此。剧集以细腻的生活质感，描摹普通人在城市洪流中的坚持、妥协与爱。",
    tags: ["现实题材", "家庭", "温情"],
    views: 890400,
    featured: false,
  },
  {
    id: "m09",
    title: "午夜列车",
    type: "电影",
    genres: ["悬疑", "惊悚"],
    region: "日本",
    year: 2025,
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=mystery%20thriller%20movie%20poster%20of%20an%20empty%20night%20train%20compartment%20with%20flickering%20lights%2C%20deep%20blue%20shadows%20and%20orange%20warning%20glow%2C%20eerie%20cinematic%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=movie-09-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20lone%20night%20train%20speeding%20through%20dark%20tunnels%20with%20glowing%20windows%2C%20deep%20blue%20darkness%20and%20warm%20orange%20interior%20light%2C%20suspenseful%20cinematic%20film%20still%2C%20high%20detail&width=1600&height=900&seq=movie-09-backdrop&orientation=landscape",
    duration: "108分钟",
    director: "是枝裕和",
    actors: ["菅田将晖", "满岛光", "妻夫木聪"],
    language: "日语",
    releaseDate: "2025-01-31",
    summary: "末班列车上七名互不相识的乘客，发现列车正驶向一张地图上不存在的地方。",
    story:
      "深夜末班车驶离站台后，车上的乘客发现窗外景色逐渐变得陌生。列车不断经过相同的站台，却始终无法到站。随着乘客逐一袒露各自不愿面对的过去，一场关于选择与救赎的困局逐步展开。影片以密闭空间营造悬疑张力，探讨记忆与遗憾。",
    tags: ["密室", "推理", "氛围"],
    views: 660800,
    featured: false,
  },
  {
    id: "m10",
    title: "雪原猎手",
    type: "电影",
    genres: ["动作", "冒险"],
    region: "美国",
    year: 2024,
    rating: 7.4,
    poster:
      "https://readdy.ai/api/search-image?query=action%20adventure%20movie%20poster%20of%20a%20hooded%20hunter%20with%20a%20rifle%20in%20a%20snowstorm%2C%20cold%20blue%20tones%20with%20warm%20orange%20sunset%20rim%20light%2C%20dramatic%20cinematic%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=movie-10-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=vast%20snowy%20wilderness%20under%20a%20dramatic%20sunset%20sky%2C%20warm%20orange%20light%20over%20cold%20blue%20snow%2C%20cinematic%20survival%20film%20still%2C%20high%20detail&width=1600&height=900&seq=movie-10-backdrop&orientation=landscape",
    duration: "124分钟",
    director: "丹尼斯·维伦纽瓦",
    actors: ["连姆·尼森", "斯嘉丽·约翰逊"],
    language: "英语",
    releaseDate: "2024-12-11",
    summary: "一场突如其来的雪崩之后，护林员必须在极寒荒野中追踪一伙亡命之徒。",
    story:
      "资深护林员杰克在暴雪封山的边境哨所执勤时，发现一伙武装走私者潜入保护区。雪崩切断了所有通讯与补给，杰克必须独自在严寒中追踪他们，阻止一场生态灾难。影片以凌厉的动作场面和壮阔的雪原风光，呈现极限环境下的人性考验。",
    tags: ["动作", "生存", "雪原"],
    views: 712300,
    featured: false,
  },
  {
    id: "m11",
    title: "我们的青春纪事",
    type: "电视剧",
    genres: ["青春", "校园"],
    region: "中国大陆",
    year: 2025,
    rating: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=nostalgic%20youth%20campus%20drama%20poster%20of%20students%20by%20a%20classroom%20window%20in%20afternoon%20sunlight%2C%20warm%20orange%20glow%20with%20soft%20blue%20shadows%2C%20gentle%20cinematic%20tone%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=movie-11-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=sunlit%20high%20school%20campus%20corridor%20with%20long%20shadows%20and%20green%20trees%2C%20warm%20orange%20afternoon%20light%20and%20soft%20blue%20tones%2C%20nostalgic%20cinematic%20film%20still%2C%20high%20detail&width=1600&height=900&seq=movie-11-backdrop&orientation=landscape",
    duration: "42分钟/集",
    director: "张一白",
    actors: ["刘昊然", "谭松韵", "董子健"],
    language: "汉语普通话",
    releaseDate: "2025-05-28",
    summary: "六个少年在高考前的那一年，经历了友情、暗恋与成长的所有阵痛与闪光。",
    story:
      "南方小城的一所重点高中里，六个性格各异的少年组成了一个学习小组。在紧张备考的日子里，他们一起经历竞赛失利、家庭矛盾与青春期的悸动。多年后回望，那段时光成为每个人心里最纯粹的记忆。剧集以真实的校园细节，唤起观众对青春的共鸣。",
    tags: ["青春", "成长", "怀旧"],
    views: 1740300,
    featured: true,
  },
  {
    id: "m12",
    title: "量子边境",
    type: "电影",
    genres: ["科幻", "动作"],
    region: "美国",
    year: 2025,
    rating: 8.9,
    poster:
      "https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20action%20movie%20poster%20of%20an%20agent%20standing%20before%20a%20glowing%20portal%2C%20deep%20blue%20energy%20with%20intense%20orange%20accents%2C%20dynamic%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=movie-12-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=dystopian%20futuristic%20city%20with%20glowing%20quantum%20portals%20and%20flying%20vehicles%2C%20deep%20blue%20and%20orange%20cinematic%20color%20grading%2C%20high%20energy%20film%20still%2C%20high%20detail&width=1600&height=900&seq=movie-12-backdrop&orientation=landscape",
    duration: "138分钟",
    director: "詹姆斯·卡梅隆",
    actors: ["汤姆·哈迪", "赞达亚", "伊德里斯·艾尔巴"],
    language: "英语",
    releaseDate: "2025-09-05",
    summary: "当平行世界的大门被打开，一名特工必须阻止两个宇宙之间的连锁崩塌。",
    story:
      "量子物理学家发明了稳定穿越平行世界的装置，却意外引发了两个宇宙之间的边界坍塌。特工凯恩被派往另一侧执行关闭装置的任务，却发现那里的自己早已死于几年前。在两个世界同时走向毁灭的倒计时中，凯恩必须做出艰难的选择。影片以震撼的视觉奇观，探讨身份与命运。",
    tags: ["量子", "平行宇宙", "视效大片"],
    views: 2088500,
    featured: true,
  },
  {
    id: "m13",
    title: "茶马古道",
    type: "电视剧",
    genres: ["历史", "剧情"],
    region: "中国大陆",
    year: 2023,
    rating: 9.0,
    poster:
      "https://readdy.ai/api/search-image?query=historical%20drama%20poster%20of%20a%20caravan%20merchant%20leading%20mules%20along%20a%20mountain%20trail%2C%20earthy%20warm%20orange%20tones%20with%20cool%20blue%20mountains%2C%20cinematic%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=movie-13-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=ancient%20tea%20horse%20road%20winding%20through%20misty%20mountains%20with%20a%20caravan%20in%20the%20distance%2C%20warm%20orange%20sunlight%20and%20cool%20blue%20mists%2C%20epic%20cinematic%20film%20still%2C%20high%20detail&width=1600&height=900&seq=movie-13-backdrop&orientation=landscape",
    duration: "50分钟/集",
    director: "孔笙",
    actors: ["陈宝国", "张丰毅", "闫妮"],
    language: "汉语普通话",
    releaseDate: "2023-10-15",
    summary: "一条绵延千年的商路，几代马帮人的血与汗，织就一段波澜壮阔的家族史诗。",
    story:
      "清末民初，云南茶商世家在动荡时局中艰难维系着世代经营的马帮商路。家族长子马致远端木讷务实，弟弟却向往新式文明。兄弟二人因理念分歧几近反目，却在匪患与战争面前重新并肩。剧集以恢弘的历史画卷，展现普通人在时代洪流中的坚守与担当。",
    tags: ["历史", "商战", "史诗"],
    views: 1956200,
    featured: false,
  },
  {
    id: "m14",
    title: "迷失东京夜",
    type: "电影",
    genres: ["剧情", "爱情"],
    region: "日本",
    year: 2024,
    rating: 7.8,
    poster:
      "https://readdy.ai/api/search-image?query=moody%20drama%20movie%20poster%20of%20a%20lone%20figure%20walking%20through%20rainy%20tokyo%20crossing%20at%20night%2C%20deep%20blue%20tones%20with%20orange%20signage%20glow%2C%20cinematic%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=movie-14-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=rainy%20tokyo%20shibuya%20crossing%20at%20night%20with%20glowing%20orange%20signs%20and%20blue%20reflections%2C%20cinematic%20urban%20film%20still%2C%20moody%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=movie-14-backdrop&orientation=landscape",
    duration: "116分钟",
    director: "岩井俊二",
    actors: ["松隆子", "福山雅治"],
    language: "日语",
    releaseDate: "2024-08-09",
    summary: "两个在深夜便利店偶遇的陌生人，用一整夜的时间，聊完了各自人生里的遗憾。",
    story:
      "加班到深夜的上班族与刚失去工作的女孩在便利店相遇。出于某种默契，两人决定一起在城市里漫无目的地走上一夜。从居酒屋到河堤，从便利店到末班车站，他们交换着各自的秘密与失落。天亮之前，这段短暂的相遇改变了两个人看待生活的方式。",
    tags: ["文艺", "都市", "治愈"],
    views: 583200,
    featured: false,
  },
  {
    id: "m15",
    title: "王牌律师",
    type: "电视剧",
    genres: ["律政", "剧情"],
    region: "韩国",
    year: 2025,
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=legal%20drama%20poster%20of%20a%20confident%20female%20lawyer%20in%20a%20dark%20suit%20before%20a%20courtroom%2C%20deep%20blue%20tones%20with%20orange%20dramatic%20light%2C%20cinematic%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=movie-15-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=empty%20dramatic%20courtroom%20with%20dramatic%20lighting%20through%20tall%20windows%2C%20deep%20blue%20shadows%20and%20warm%20orange%20sunlight%2C%20cinematic%20film%20still%2C%20high%20detail&width=1600&height=900&seq=movie-15-backdrop&orientation=landscape",
    duration: "62分钟/集",
    director: "朴赞郁",
    actors: ["金高银", "李栋旭", "韩孝周"],
    language: "韩语",
    releaseDate: "2025-06-20",
    summary: "一位从未败诉的王牌律师，接手了一桩看似铁证如山、却处处透着蹊跷的案子。",
    story:
      "顶尖律所的王牌律师车瑞英接受了职业生涯中最棘手的一桩辩护——为一名被指控谋杀的企业家辩护。随着调查深入，她发现所有证据都完美得可疑。在追查真相的过程中，她不得不直面自己过往的一桩旧案。剧集以缜密的推理和犀利的庭审对决，探讨法律的边界与人性的复杂。",
    tags: ["律政", "悬疑", "庭审"],
    views: 1320900,
    featured: false,
  },
  {
    id: "m16",
    title: "荒野求生",
    type: "电影",
    genres: ["冒险", "剧情"],
    region: "加拿大",
    year: 2024,
    rating: 7.7,
    poster:
      "https://readdy.ai/api/search-image?query=survival%20drama%20movie%20poster%20of%20a%20rugged%20man%20building%20a%20fire%20in%20a%20vast%20forest%20at%20dusk%2C%20cool%20blue%20woods%20with%20warm%20orange%20firelight%2C%20cinematic%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=movie-16-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=endless%20wild%20forest%20and%20river%20valley%20under%20a%20dramatic%20sky%2C%20warm%20orange%20sunset%20against%20cool%20blue%20tones%2C%20cinematic%20survival%20film%20still%2C%20high%20detail&width=1600&height=900&seq=movie-16-backdrop&orientation=landscape",
    duration: "122分钟",
    director: "阿方索·卡隆",
    actors: ["莱昂纳多·迪卡普里奥", "克里斯汀·斯图尔特"],
    language: "英语",
    releaseDate: "2024-10-04",
    summary: "一场空难把一位城市建筑师抛入无人荒野，他必须重新学会如何像一个原始人那样活下去。",
    story:
      "建筑师亚历克斯乘坐的小飞机在加拿大北部荒野坠毁。唯一的幸存者他必须在零下的森林中求生，等待渺茫的救援。从生火到捕鱼，从搭棚到对抗野兽，他在与大自然的搏斗中逐渐剥离了文明的外壳。影片以近乎纪实的镜头，呈现人类求生的本能与毅力。",
    tags: ["求生", "自然", "硬核"],
    views: 654700,
    featured: false,
  },
];

export const genresList = ["科幻", "悬疑", "爱情", "古装", "犯罪", "动作", "剧情", "都市", "青春", "冒险", "家庭", "武侠"];
export const regionsList = ["中国大陆", "美国", "中国香港", "韩国", "日本", "英国", "加拿大"];
export const yearsList = [2025, 2024, 2023, 2022];
export const ratingOptions = [
  { label: "9分以上", value: 9 },
  { label: "8分以上", value: 8 },
  { label: "7分以上", value: 7 },
];